import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { DevPortalSwitcher } from '../components/DevPortalSwitcher';
import { SessionExpiryHost } from '../components/ui/session-expiry-host';
import { ToastProvider } from '../components/ui/toast';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <ToastProvider>
      <Outlet />
      <SessionExpiryHost />
      {/* Dev-only: `import.meta.env.DEV` is false in a production build, so Cloudflare never ships the switcher. */}
      {import.meta.env.DEV ? <DevPortalSwitcher /> : null}
    </ToastProvider>
  ),
});
